import { safeJsonParse } from "@/zapi-frontend/utils/safeJsonParse";

export const removeContentFromResponse = (responseStringifiedJson: string) => {
  const parsed = safeJsonParse(responseStringifiedJson);
  if (parsed?.type === "answer" || parsed?.type === "agent" || parsed?.type === "answerAndUpdate") {
    return responseStringifiedJson;
  }

  const parsedWithReplacedContent = { ...parsed, content: "" };
  return JSON.stringify(parsedWithReplacedContent);
};
